export default {
    lang: {
        name: 'Duration'
    }
}